import React from 'react';
import { Button, Popconfirm, Space, Tag, Typography } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { LotteryFulfillmentStatus, LotteryPrize, LotteryRecord } from '../../types/lottery';
import { fulfillmentColors, fulfillmentLabels } from './detailUtils';

const { Text } = Typography;

export const createPrizeColumns = (
  onEdit: (prize: LotteryPrize) => void,
  onDelete: (prize: LotteryPrize) => void,
): ColumnsType<LotteryPrize> => [
  { title: '排序', dataIndex: 'sortOrder', width: 70 },
  {
    title: '奖品',
    dataIndex: 'name',
    render: (name, record) => (
      <Space direction="vertical" size={2}>
        <Space wrap>
          <Text strong>{name}</Text>
          {record.isNoPrize && <Tag>未中奖项</Tag>}
          <Tag color={record.isActive ? 'green' : 'red'}>{record.isActive ? '启用' : '停用'}</Tag>
        </Space>
        {record.description && <Text type="secondary">{record.description}</Text>}
      </Space>
    ),
  },
  { title: '权重', dataIndex: 'weight', width: 90 },
  {
    title: '库存',
    width: 140,
    render: (_, record) => (record.stock === -1 ? '不限量' : `${record.remainingStock}/${record.stock}`),
  },
  {
    title: '操作',
    width: 150,
    render: (_, record) => (
      <Space>
        <Button size="small" icon={<EditOutlined />} onClick={() => onEdit(record)}>编辑</Button>
        <Popconfirm title="确认删除该奖品？" description="已有抽奖记录的奖品会自动停用。" onConfirm={() => onDelete(record)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    ),
  },
];

export const createRecordColumns = (
  onFulfill: (record: LotteryRecord) => void,
): ColumnsType<LotteryRecord> => [
  {
    title: '时间',
    dataIndex: 'createdAt',
    width: 170,
    render: (value) => String(value).replace('T', ' ').slice(0, 19),
  },
  { title: '订单号', dataIndex: 'orderNo', width: 150 },
  { title: '手机号', dataIndex: 'phone', width: 130 },
  {
    title: '奖品',
    dataIndex: 'prizeName',
    render: (value, record) => (
      <Space>
        <Tag color={record.isWinning ? 'gold' : 'default'}>{record.isWinning ? '中奖' : '未中奖'}</Tag>
        <span>{value}</span>
      </Space>
    ),
  },
  {
    title: '兑奖状态',
    dataIndex: 'fulfillmentStatus',
    width: 110,
    render: (value: LotteryFulfillmentStatus) => (
      <Tag color={fulfillmentColors[value]}>{fulfillmentLabels[value]}</Tag>
    ),
  },
  { title: '备注', dataIndex: 'fulfillmentNote', ellipsis: true },
  {
    title: '操作',
    width: 120,
    render: (_, record) => (
      record.isWinning && record.fulfillmentStatus !== 'fulfilled' ? (
        <Button size="small" type="primary" onClick={() => onFulfill(record)}>标记兑奖</Button>
      ) : null
    ),
  },
];
